import EventBusConst from '@/events/event.bus.const';
import OrgSelectedEventPayload from '@/events/entities/org.selected';
import siteConfigService from '@/services/site.config.service';
import { EventBus, EventBusEmit } from '@/events/event.bus';
import EventHandledStatus from '@/events/entities/event.handled.status';
import EventHandledCode from '@/events/entities/event.handled.code';
import storageService from '@/services/storage.service';
import Logger from '@/utils/logger.utils';
import store from '@/store';
import { commonService } from '@ol/ol-ui-core';


class OrgSelectedEventHandler implements baseEventHandler {
  private that: OrgSelectedEventHandler;
  constructor() {
    this.that = this;
  }
  register() {
    EventBus.$on(EventBusConst.SELECTED_CUR_ORG_EVENT, this.handleOrgSelectedEvent);
    Logger.debug('registered OrgSelectedEventHandler!!');
  }
  unRegister() {
    EventBus.$off(EventBusConst.SELECTED_CUR_ORG_EVENT, this.handleOrgSelectedEvent);
    Logger.debug('unRregistered OrgSelectedEventHandler!!');
  }

  public async handleOrgSelectedEvent(orgSelectedEventPayload: OrgSelectedEventPayload): Promise<EventHandledStatus<OrgSelectedEventPayload>> {
    let apiEndpoint: any = await siteConfigService.getApiEndpoint('organization.selectorUrl');

    const plId: number = orgSelectedEventPayload.plId;
    const orgId: number = orgSelectedEventPayload.orgId;
    let orgSelectItemId: string = orgSelectedEventPayload.orgSelectItemId;
    const plIdOrgIdFromOrgSelectItemId: Array<string> = (orgSelectItemId || '').split('_');
    if (plIdOrgIdFromOrgSelectItemId && plIdOrgIdFromOrgSelectItemId.length === 2 && plIdOrgIdFromOrgSelectItemId[0].trim() === plId.toString() && plIdOrgIdFromOrgSelectItemId[1].trim() === orgId.toString()) {
      orgSelectItemId = `${orgId}-${plId}`;
    }

    await commonService.getOrGenerateCommonProperties(plId, orgId, null, null, null);

    if (!!plId && plId > 0) {
      await storageService.savePrivateLabel(plId, null);
    }
    apiEndpoint = apiEndpoint.replace('{orgValueSelected}', orgSelectItemId);
    apiEndpoint = apiEndpoint.replace('{orgId}', orgId);
    apiEndpoint = apiEndpoint.replace('{plId}', plId);

    const eventHandledStatus: EventHandledStatus<OrgSelectedEventPayload> =
      {
        code: EventHandledCode.OK,
        msg: `org selected event handled for ${orgSelectedEventPayload.orgSelectItemId}`,
        original: orgSelectedEventPayload,
        extra: { 'organization.selectorUrl': apiEndpoint },
      };
    Logger.debug(eventHandledStatus);
    return eventHandledStatus;
  }
}

export default new OrgSelectedEventHandler();
